import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

export const isCourseEvergreen = (course?: Nullable<Partial<CourseApiModel>>) =>
  Boolean(course?.is_autorestarting);
